module.exports = __webpack_public_path__ + "img/democratic-republic-of-congo.945491f2.svg";